const firebaseConfig = {
    apiKey: "AIzaSyBxYQuzGVI71czzySEYSATuAZEF1nbUjl8",
    authDomain: "mern-creative-agency.firebaseapp.com",
    databaseURL: "https://mern-creative-agency.firebaseio.com",
    projectId: "mern-creative-agency",
    storageBucket: "mern-creative-agency.appspot.com",
    messagingSenderId: "1001652064477",
    appId: "1:1001652064477:web:ff0defa1b2cc0a3cadcb34"
  };

  export default firebaseConfig;